import React, { useState } from "react";
import { Link } from "react-router-dom";
import { WalletIcon, ArrowDownIcon } from "assets/icons";

export default function Header({ showMobileHeader }) {
  const [isUser, setIsUser] = useState(false);

  const nav = [
    {
      label: "Home",
      link: "/",
    },
    {
      label: "Book Tickets",
      link: "/book-tickets",
    },
    {
      label: "Promotions",
      link: "/",
    },
    {
      label: "Contact Us",
      link: "/",
    },
    {
      label: "About",
      link: "/",
    },
  ];

  return (
    <>
      {/* Desktop */}
      <div className="h-[80px] bg-white sticky top-0 left-0 right-0 z-[999] justify-center hidden lg:flex">
        <div className="w-full max-w-8xl margins flex items-center">
          <div className="flex-1 flex items-center">
            <Link to="/">
              <img
                src="/images/logo.jpeg"
                alt="logo"
                className="h-[64px] mr-[54px]"
              />
            </Link>

            <div className="flex items-center gap-[30px]">
              {nav.map((item, index) => (
                <Link
                  key={index}
                  to={item.link}
                  className="text-base text-[#2B2B2B] font-semibold"
                >
                  {item.label}
                </Link>
              ))}
            </div>
          </div>
          <div className="flex items-center gap-8">
            {isUser ? (
              <div className="flex items-center gap-12">
                <div className="flex items-center gap-1">
                  <div className="flex items-center justify-center h-5 w-5">
                    <WalletIcon />
                  </div>
                  <h4 className="text-[#235DFF] font-semibold text-sm">
                    RM 510.00
                  </h4>
                </div>
                <div className="flex items-center gap-3">
                  <div
                    className="bgImage !h-[45px] !min-w-[45px] !w-[45px] rounded-full relative"
                    style={{ backgroundImage: `url(/images/user-1.jpeg)` }}
                  >
                    <div className="flex items-center justify-center h-4 w-4 bg-white rounded-full absolute bottom-0 right-0 cursor-pointer">
                      <ArrowDownIcon />
                    </div>
                  </div>
                  <h1 className="text-[#112211] font-semibold text-base">
                    John D.
                  </h1>
                </div>
              </div>
            ) : (
              <>
                <Link to="/" className="text-sm text-[#858585] font-semibold">
                  Sign Up
                </Link>
                <button
                  onClick={() => setIsUser(true)}
                  className="bg-primary-700 text-sm text-white font-semibold px-6 py-3 rounded-lg hover:opacity-90"
                >
                  Login
                </button>
              </>
            )}
          </div>
        </div>
      </div>

      {/* Mobile */}
      <div
        className={`w-full absolute top-0 right-0 py-10 flex items-center lg:hidden margins ${
          showMobileHeader ? "" : "hidden"
        }`}
      >
        {isUser ? (
          <div className="flex items-center gap-2">
            <div
              className="bgImage !h-[46px] !min-w-[46px] !w-[46px] rounded-full relative"
              style={{ backgroundImage: `url(/images/user-1.jpeg)` }}
            />
            <div className="flex flex-col gap-1">
              <h1 className="text-white font-semibold text-base">
                Welcome, Damon! 👋🏻
              </h1>
              <div className="text-sm text-white font-medium">
                Explore the world with us.
              </div>
            </div>
          </div>
        ) : (
          <div className="flex items-center gap-6">
            <Link to="/" className="text-sm text-white font-semibold">
              Sign Up
            </Link>
            <button
              onClick={() => setIsUser(true)}
              className="bg-primary-700 text-sm text-white font-semibold px-6 py-3 rounded-lg hover:opacity-90"
            >
              Login
            </button>
          </div>
        )}
      </div>
    </>
  );
}
